import React, { Component } from 'react';
import Navigation from './Navigation';
import 'materialize-css/dist/css/materialize.min.css';
import M from "materialize-css";
import GiftList from './GiftList'
import * as CONS from '../CONS'
import jwt from 'jsonwebtoken';
import Select from 'react-select'
import '../style/GiftForm.css';
import registro from '../img/beneficios/registro.json';

class GiftForm extends Component {

    constructor(props) {
        super(props);
        if (!localStorage.getItem('jwtToken')) {
            this.props.history.push("/login");
            window.location.reload();
        } else {
            var token = localStorage.getItem("jwtToken");
            const tokenDec = jwt.decode(token);
            if (tokenDec.level < 15) {
                this.props.history.push("/login");
                // window.location.reload();
            }
        }
    }

    state = {
        status: '',
        id_gift: '',
        name: '',
        point: '',
        description: '',
        image: 'ico_default.png',
        created_by: 0,
        level: 0,
        // active: true,
        gift_list: [],
        isNew: true,        //true: Insertar nuevo, false: Actualizar
        btnSubmit: "Registrar Regalo",
        arrayGiftState: [],
        id_gift_state: [{
            value: 1, label: 'Activo'
        }],

        optionsGiftState: []
    };



    //  Verifica que los campos tengan valores adecuados
    validate() {
        if (this.state.level < 15) {
            this.setState({ status: "No tiene permisos suficientes" });
            return false;
        }

        if (this.state.name.length <= 0 || this.state.name.length > 45) {
            this.setState({ status: "El nombre es de máximo 45 caracteres" });
            return false;
        }

        if (this.state.description.length > 300) {
            this.setState({ status: "La descripción es de máximo 300 caracteres" });
            return false;
        }

        if (this.state.point < 0 || this.state.point > 1000000) {
            this.setState({ status: "Los puntos deben ser enteros entre 0 y 1.000.000" });
            return false;
        }

        return true;
    }

    // Agrega un regalo de la lista al formulario para actualizarlo
    async setUpdateGift(gift) {
        gift.id_gift_state = this.state.optionsGiftState.find(g => g.value === gift.id_gift_state);

        await this.setState(gift);
        await this.fetchGiftList();
        M.updateTextFields();
    }

    //  Envía el regalo por post para insertarlo desde el server
    async insertGift() {
        var {
            name,
            point,
            description,
            image,
            created_by,
            id_gift_state } = this.state;
        id_gift_state = id_gift_state.value;

        try {
            const response = await fetch(localStorage.getItem("api") + '/gift/', {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                }),
                body: JSON.stringify(
                    {
                        name,
                        point,
                        description,
                        image,
                        created_by,
                        id_gift_state
                    }
                )
            });
            const data = await response.json();
            this.setState({ status: data.status });
        } catch (err) {
            console.log(err);
            this.setState({ status: CONS.err_server });
        }
    }

    //  Envía el regalo por put para actualizarlo desde el server
    async updateGift() {
        var {
            id_gift,
            name,
            point,
            description,
            image,
            created_by,
            id_gift_state } = this.state;
        id_gift_state = id_gift_state.value;

        try {
            const response = await fetch(localStorage.getItem("api") + '/gift/' + id_gift, {
                method: 'PUT',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                }),
                body: JSON.stringify(
                    {
                        id_gift,
                        name,
                        point,
                        description,
                        image,
                        created_by,
                        id_gift_state
                    }
                )
            })
            const data = await response.json();
            this.setState({ status: data.status });
        } catch (err) {
            console.log(err);
            this.setState({ status: CONS.err_server });
        }
    }

    //  Llama al server por get y trae el listado de estados de regalos
    async fetchGiftState() {
        try {
            const response = await fetch(localStorage.getItem("api") + '/gift_state/', {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                })
            })
            const arrGiftState = await response.json();
            const optionsGiftState = arrGiftState.length > 0 ?
                arrGiftState.map((v, i) =>
                    (
                        { value: v.id_gift_state, label: v.name }
                    )
                ) : [];
            this.setState({ optionsGiftState: optionsGiftState });
        } catch (err) {
            console.log(err);
            this.setState({ status: CONS.err_server });
        }
    }

    //  Llama al server por get y trae el listado de regalos
    //  También actualiza el listado
    async fetchGiftList() {
        try {
            const response = await fetch(localStorage.getItem("api") + '/gift/', {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                })
            })
            const data = await response.json();
            this.setState({ gift_list: data });
        } catch (err) {
            console.log(err);
            this.setState({ status: CONS.err_server });
        }
    }

    //  Crea el array de roles para el Select
    createSelectGiftState() {
        var id_gift_state = [];

        this.state.arrayGiftState.map((item) =>
            id_gift_state.push(<option key={item.id_gift_state} value={item.id_gift_state}>{item.name}</option>)
        );

        return id_gift_state;
    }

    // Limpia los campos y actualiza state a su estado inicial
    cleanFields() {
        // e.preventDefault();
        this.setState({
            id_gift: '',
            name: '',
            description: '',
            point: '',
            // active: true,
            isNew: true,
            btnSubmit: "Registrar Regalo",
            id_gift_state: this.state.optionsGiftState.find(g => g.value === 1)
        });
        M.updateTextFields();
    }

    // Crea el botón de agregar regalo, cuando se ha actualizado uno.
    newGiftButton() {
        if (this.state.isNew) {
            return;
        } else {
            return <button className="btn" id="" type="btn" onClick={() => this.cleanFields()}>+</button>;
        }
    }


    //  Llama al componente GiftList con la lista de los regalos
    getGiftList() {
        return this.state.gift_list.map((gift, key) => {
            return <GiftList
                gift={gift} key={key}
                refresh={this.fetchGiftList.bind(this)}
                update={this.setUpdateGift.bind(this)} />
        })
    }


    /*
        Realiza el setState para el componente Select
    */
    handleChangeSelect(e, name) {
        this.setState({ [name]: e === null ? [] : e })
    }

    //  Actualiza el estado de los Checkbox
    handleCheckBoxChanged = (e) => {
        this.setState({
            [e.target.name]: e.target.checked
        });
    }

    //  Actualiza el estado de los Input
    handleInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    //  Se llama al enviar el formulario
    handleSubmit = async (e) => {
        e.preventDefault();

        if (this.validate()) {
            if (this.state.isNew) {
                await this.insertGift();
            } else {
                await this.updateGift();
            }
            await this.fetchGiftList();
        }
    }

    getUser() {
        var token = localStorage.getItem("jwtToken");

        this.setState({
            created_by: jwt.decode(token).id_user,
            level: jwt.decode(token).level
        });
    }

    componentDidMount() {
        this.getUser();
        this.fetchGiftList();
        this.fetchGiftState();

        var elems = document.querySelectorAll('input#name, textarea');
        M.CharacterCounter.init(elems);

        var elemModal = document.querySelectorAll('.modal');
        M.Modal.init(elemModal);
    }

    render() {
        const { id_gift_state, optionsGiftState } = this.state;

        var asterisk = <span className="asterisk">*</span>
        const tableImages = registro.images.map((img, index) =>
            <a key={index} href='#!' className="col s2" onClick={() => this.setState({ image: img })}>
                <img src={require('../img/beneficios/' + img)} alt={img}></img></a>
        );

        return (
            <React.Fragment>
                <div className="shape-border-left hide-on-med-and-down"></div>
                <Navigation></Navigation>
                <div id="GiftForm" className="">
                    <div className="row">
                        <div id="form-gift" className="col s12 m12 l4">
                            <label >{this.state.status}</label>
                            <div className="row">
                                <form onSubmit={this.handleSubmit}>
                                    <div className="input-field col s12 l8 offset-l2 left-align">
                                        <input id="name" name="name" type="text" className="validate" value={this.state.name} required onChange={this.handleInputChange} data-length="45" maxLength="45" />
                                        <label htmlFor="name" className="active otro">Nombre del regalo{asterisk}</label>
                                    </div>
                                    <div className="input-field col s12 l8 offset-l2 left-align">
                                        <input id="point" name="point" type="number" className="validate" value={this.state.point} min="0" max="1000000" required onChange={this.handleInputChange} />
                                        <label htmlFor="point">Puntos{asterisk}</label>
                                    </div>
                                    <div className="input-field col s12 l8 offset-l2 left-align">
                                        <textarea id="description" name="description" className="materialize-textarea" value={this.state.description} onChange={this.handleInputChange} data-length="300" maxLength="300"></textarea>
                                        <label htmlFor="description">Descripción</label>
                                    </div>
                                    <div className="col s12 l8 offset-l2 left-align">
                                        <Select name="id_gift_state" classNamePrefix="select-map" options={optionsGiftState} placeholder="Estado del beneficio"
                                            value={id_gift_state} onChange={(e) => this.handleChangeSelect(e, "id_gift_state")}></Select>
                                    </div>
                                    <div className="input-field col s12 l8 offset-l2 left-align">
                                        <a href="#!" data-target="modal1" className="icon modal-trigger"> <i className="material-icons">image</i> Eligir Icono</a>
                                    </div>
                                    <div className="input-field col s12 l8 offset-l2">
                                        <input className="btn" id="submit" type="submit" value={this.state.btnSubmit} />
                                    </div>
                                    <div className="input-field col s12 l8 offset-l2">
                                        {this.newGiftButton()}
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div id="table-gift" className="col s12 m12 l8">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Descripción</th>
                                        <th>Puntos</th>
                                        <th>Activo</th>
                                        <th>Editar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.getGiftList()}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div id="modal1" className="modal">
                        <div className="modal-content">
                            <h4>Icono actual: </h4>
                            <div className="row current-image">
                                <img src={require('../img/beneficios/' + this.state.image)} alt="icono actual"></img>
                            </div>
                            <p>Elige el icono que mejor represente el beneficio</p>
                            <div className="row images-gift">
                                {tableImages}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <a href="#!" className="modal-close waves-effect waves-green btn-flat">Listo</a>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }

}

export default GiftForm